import * as React from 'react';

import { Button, EButtonSize, EButtonStyle } from '@my/myworld-ui-kit';
import { inject } from 'mobx-react';
import { parseUrl } from 'query-string';

import { EStore } from '@enums';

import { URLS } from '@base/constants';

import { IMainProps, IMainState } from './types';

import * as s from './Main.scss';

@inject(EStore.CURRENT_USER)
export class Main extends React.Component<IMainProps, IMainState> {

	state: IMainState = {
		login: '',
		domain: 'mail.ru',
		password: '',
		error: '',
		isLoading: false,
	};

	onLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ login: event.currentTarget.value });

	onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ password: event.currentTarget.value });

	onDomainChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ domain: event.currentTarget.value });

	onSubmit = async () => {
		const {
			login,
			password,
			domain,
		} = this.state;
		const { query } = parseUrl(location.href);

		this.setState({
			isLoading: true,
			error: '',
		});

		try {
			await this.props.currentUserStore.localAuth({
				login,
				password,
				domain,
			});
			location.href = query.page ? query.page as string : `${location.origin}${URLS.APPS}`;
		} catch (err) {
			this.setState({
				error: 'Wrong login or password',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	render() {
		const {
			currentUser,
		} = this.props.currentUserStore;

		return <div className={s.block}>
			<input placeholder={currentUser.email || 'login'} onChange={this.onLoginChange}/>
			<br/>
			<select defaultValue="mail.ru" onChange={this.onDomainChange}>
				<option value="mail.ru">@mail.ru</option>
				<option value="inbox.ru">@inbox.ru</option>
				<option value="bk.ru">@bk.ru</option>
				<option value="list.ru">@list.ru</option>
			</select>
			<br/>
			<input placeholder="password" type="password" onChange={this.onPasswordChange}/>
			<br/>
			<Button
				style={EButtonStyle.PRIMARY_ACCENT}
				size={EButtonSize.M}
				label="Submit"
				onClick={this.onSubmit}
			/>
			{Boolean(this.state.isLoading) && <> <br/><span>loading...</span></>}
			{Boolean(this.state.error?.length) && <> <br/><span style={{ color: 'red' }}>{this.state.error}</span></>}
		</div>;
	}

}
